import React from "react";
import "./Footer.css";

const Footer = () => {
    return (

    <footer className="super-footer">
            {/* Top Section */}
            <div className="footer-top">
                {/* Company Info */}
                <div className="footer-about">
                    <img src="/images/auditlogo.png" alt="AuditUSI ERP Logo" className="footer-logo" />
                    <p>
                        Empowering businesses with smart ERP solutions.
                        Manage your operations, finances, and people with ease.
                    </p>
                </div>

                {/* Quick Links */}
                <div className="footer-links">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/Productoverview">Product Overview</a></li>
                        <li><a href="/whatsnew">What's New</a></li>
                        <li><a href="/Pricing">Pricing</a></li>
                        <li><a href="/Support">Support</a></li>
                        <li><a href="/Features">Features</a></li>
                        <li><a href="/Industrial-specification">Industrial Specifics</a></li>
                    </ul>
                </div>

                <div className="footer-links">
                    <h3>Support</h3>
                    <ul>
                        <li><a href="/creation/productcreation">Product Creation</a></li>
                        <li><a href="/creation/accountcreation">Account Creation</a></li>
                        <li><a href="/creation/salesbills">Sales Entry</a></li>
                        <li><a href="/creation/purchasebills">Purchase Entry</a></li>
                    </ul>
                </div>

                {/* Services */}
                <div className="footer-links">
                    <h3>Services</h3>
                    <ul>
                        <li>ERP Implementation</li>
                        <li>Custom Development</li>
                        <li>24/7 Support</li>
                        <li>Training</li>
                        <li>Integrations</li>
                    </ul>
                </div>

                {/* Downloads Section */}
                <div className="footer-links">
                    <h3>Downloads</h3>
                    <ul>
                        <li><a href="/Download/Downloads/Auditusierp18.5.5.9.rar">Auditusierp 18.5.5.9</a></li>
                        <li><a href="/Download/Downloads/AuditusierpReportTool 18.5.5.9.rar">Report Tool</a></li>  
                        <li><a href="/Download/Downloads/mysql 8.0.31.rar">MySQL 8.0.31</a></li>
                    </ul>
                </div>

                {/* Mobile App Downloads Section */}
                <div className="footer-links">
                    <h3>Download Mobile App</h3>
                    <ul>
                        <li><a href="/Download/Mobile_app/AuditRack.apk" target="_blank" rel="noopener noreferrer">AuditRack Mobile App (Android)</a></li>
                        <li><a href="/Download/Mobile_app/AuditusIerp-Mobileapp.apk" target="_blank" rel="noopener noreferrer">Auditusierp Mobile App (Android)</a></li>
                    </ul>
                </div>

                {/* Contact Info */}
                <div className="footer-contact">
                    <h3>Contact Us</h3>
                    <p>📞 +91 9032032612</p>
                    <p>✉️ auditusierp@gmail.com</p>
                </div>
            </div>

     

            {/* Get Demo Button and Social Icons side by side */}
            <div className="get-demo-btn-wrapper">
                <button className="get-demo-btn gradient-light-effect">
                    Get Demo
                </button>
                <div className="footer-social">
                    <a href="https://facebook.com/auditusierp" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://instagram.com/auditusierp" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
                    <a href="https://youtube.com/@auditusierp" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
                    <a href="https://twitter.com/auditusierp" target="_blank" rel="noreferrer"><i className="fab fa-x-twitter"></i></a>
                </div>
            </div>

            {/* Centered Bottom Section */}
            <div className="footer-bottom">
                <p style={{ margin: 0 }}>© {new Date().getFullYear()} IPCA SOFTWARE SOLUTIONS PVT. LTD. | All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
